<template>
  <div>
    <div class="m-bod" @click="showMsg">{{ $t("msg.msg") }}</div>
    <div class="m-msg" :class="[show ? 'show' : '']">
      <div class="tit">
        <div class="t">{{ $t("msg.tit") }}</div>
        <span class="close" @click="closeMsg"></span>
      </div>
      <div class="form">
        <textarea
          name=""
          class="area"
          :placeholder="$t('msg.holder1')"
          v-model="area"
        ></textarea>
        <div class="group">
          <div class="icon">
            <img src="../assets/images/ly-1.png" alt="" />
          </div>
          <div class="oh">
            <input
              type="text"
              class="inp"
              :placeholder="$t('msg.holder2')"
              v-model="name"
            />
          </div>
        </div>
        <div class="group">
          <div class="icon">
            <img src="../assets/images/ly-2.png" alt="" />
          </div>
          <div class="oh">
            <input
              type="number"
              class="inp"
              :placeholder="$t('msg.holder3')"
              v-model="tel"
            />
          </div>
        </div>
        <div class="group">
          <div class="icon">
            <img src="../assets/images/ly-3.png" alt="" />
          </div>
          <div class="oh">
            <input
              type="email"
              class="inp"
              :placeholder="$t('msg.holder4')"
              v-model="email"
            />
          </div>
        </div>
        <div class="group">
          <div class="icon">
            <img src="../assets/images/ly-4.png" alt="" />
          </div>
          <div class="oh">
            <input
              type="text"
              class="inp"
              :placeholder="$t('msg.holder5')"
              v-model="company"
            />
          </div>
        </div>
        <div class="btn">
          <div class="send" @click="sendMsg">{{ $t("msg.btn") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
  data () {
    return {
      area: '',
      name: '',
      tel: '',
      email: '',
      company: '',
      show: false
    }
  },
  /* created () {
    let that = this;
    let lang = localStorage.getItem("locale") || 'zh';
    that.lang = lang;
  }, */
  methods: {
    // 打开留言框
    showMsg () {
      this.show = !this.show
    },
    // 关闭留言框
    closeMsg () {
      this.show = false
    },
    // 发送信息
    sendMsg () {
      let that = this;
      let obj = {};
      let tip1, tip2, tip3, tip3_1, tip4, tip4_1;
      /* if (that.lang === 'zh') {
        tip1 = '请输入留言'
        tip2 = '请输入您的姓名'
        tip3 = '请输入您的电话'
        tip3_1 = '电话格式错误'
        tip4 = '请输入您的邮箱'
        tip4_1 = '邮箱格式错误'
      } else if (that.lang === 'en') {
        tip1 = 'Please enter a message'
        tip2 = 'Please enter your name'
        tip3 = 'Please enter your phone number'
        tip3_1 = 'Phone format error'
        tip4 = 'Please enter your email'
        tip4_1 = 'Email format error'
      } */

      tip1 = 'Please enter a message'
      tip2 = 'Please enter your name'
      tip3 = 'Please enter your phone number'
      tip3_1 = 'Phone format error'
      tip4 = 'Please enter your email'
      tip4_1 = 'Email format error'
      obj.message = that.area
      obj.name = that.name
      obj.tel = that.tel
      obj.email = that.email
      obj.company = that.company
      // 验证留言
      if (obj.message == '') {
        // console.log(tip1);
        that.$message(
          {
            message: tip1,
            type: 'warning'
          }
        );
        return false;
      }
      // 验证姓名
      if (obj.name == '') {
        that.$message(
          {
            message: tip2,
            type: 'warning'
          }
        );
        return false;
      }
      // 验证手机号
      if (obj.tel == '') {
        that.$message(
          {
            message: tip3,
            type: 'warning'
          }
        )
        return false;
      } /*else {
        if (!/^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(obj.tel)) {
          that.$message(
            {
              message: tip3_1,
              type: 'warning'
            }
          );
          return false;
        }
      }*/
      // 验证邮箱
      if (obj.email == '') {
        that.$message(
          {
            message: tip4,
            type: 'warning'
          }
        )
        return false;
      } else {
        let reg = /^[A-Za-z0-9-_.\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!reg.test(obj.email)) {
          that.$message(
            {
              message: tip4_1,
              type: 'warning'
            }
          );
          return false;
        }
      }
      that.postMsg(obj);
      Loading.service();
    },
    // 发送至后台接口
    postMsg (obj) {
      let that = this;
      let txt;
      /* if (that.lang === 'zh') {
        txt = '发送成功！'
      } else if (that.lang === 'en') {
        txt = 'Sending succeeded!'
      } */
      txt = 'Sending succeeded!'

      let data = {
        message: obj.message,
        guestName: obj.name,
        guestTel: obj.tel,
        guestMail: obj.email,
        guestCompany: obj.company || '',
        type: 'online'
      };
      that.$http
        .postMsg(data)
        .then((res) => {
          if (res.code == 200) {
            Loading.service().close();
            that.$message(
              {
                message: txt,
                type: 'success'
              }
            );
            that.show = false
            return false;
          }
        })
    },

  },
}
</script>

<style lang="scss" scoped>
.m-bod {
  position: fixed;
  top: 50%;
  right: 0;
  margin-top: -37px;
  cursor: pointer;
  // border-radius: 5px;
  height: 74px;
  width: 74px;
  background-color: #00aef3;
  background-repeat: no-repeat;
  background-position: 50% 24%;
  background-size: 32px;
  background-image: url(../assets/images/msg.png);
  z-index: 100;
  text-align: center;
  padding-top: 45px;
  font-size: 14px;
  color: #fff;
  border-radius: 10px;
}

.m-msg {
  position: fixed;
  left: 20px;
  bottom: 20px;
  width: 240px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.4);
  z-index: 1;
  visibility: hidden;
  opacity: 0;
  transform: translateY(120%);
  transition: 0.6s;

  &.show {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }

  .tit {
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    background-color: #4e6ef2;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .t {
      float: left;
      font-size: 14px;
      color: #fff;
      margin-left: 12px;
      line-height: 46px;
      padding-left: 2px;
    }
    .close {
      float: right;
      height: 46px;
      width: 34px;
      cursor: pointer;
      background: transparent
        url(//sgoutong.baidu.com/embed/1632285737/asset/embed/css/pc/message/img/nodeMin.png)
        no-repeat;

      background-position: 0 center;
      background-size: 50%;
    }
  }
  .form {
    overflow: hidden;
    padding: 0 13px;
  }
  .group {
    height: 33px;
    margin: 8px auto 0;
    border: 1px solid #dcdfe6;
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    font-size: 14px;
    overflow: hidden;
  }
  .area {
    display: block;
    width: 100%;
    height: 70px;
    margin: 12px auto 7px;
    padding: 10px 12px;
    resize: none;
    overflow: hidden;
    border: 1px solid #dcdfe6;
    background-color: #fff;
    text-align: left;
    outline: 0;
    border-radius: 4px;
    font-size: 12px;
    line-height: 18px;
  }
  .icon {
    float: left;
    width: 35px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background-color: #fff;
    vertical-align: top;
    border-right: 1px solid #fff;
    border-radius: 4px 0 0 4px;
    img {
      display: inline-block;
      vertical-align: middle;
      max-height: 16px;
    }
  }
  .oh {
    overflow: hidden;
  }
  .inp {
    display: block;
    width: 100%;
    height: 32px;
    border: none;
    outline: 0;
  }
  .btn {
    overflow: hidden;
    padding: 13px 0;
    .send {
      height: 32px;
      width: 64px;
      line-height: 32px;
      text-align: center;
      border-radius: 4px;
      font-size: 12px;
      color: #fff;
      cursor: pointer;
      float: right;
      background-color: #4e6ef2;
      transition: 0.3s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
::-webkit-input-placeholder {
  color: #999;
  font-size: 12px;
}
::-moz-placeholder {
  color: #999;
  font-size: 12px;
}
::-ms-input-placeholder {
  color: #999;
  font-size: 12px;
}
@media screen and (max-width: 1800px) {
  .m-bod{
   width: 4.11vw;
   height: 4.11vw;
   background-size: 1.77vw;
   padding-top: 2.5vw;
   font-size: 0.777vw;
  }
}

@media screen and (max-width: 960px) {
  .m-bod {
    top: 60%;
    width: 74px;
    height: 74px;
    background-size: 32px;
    font-size: 14px;
    padding-top: 45px;
    margin-top: 0;
    zoom: 0.8;
  }
}
</style>
